import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_vaddvj6a8j: FaireBrandEntity = {
  token: "b_vaddvj6a8j",
  type: "brand",
  name: "For the Love of Dough Co",
  avatarUrl:
    "https://cdn.faire.com/fastly/6466bceb4563118f9190f27b81500215b9e5930c320541a52812906360e2acba.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e946b2aa06e1fe29dcd54f01ca9e83176651809a5208f552cfa02b12a94d9120.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/6466bceb4563118f9190f27b81500215b9e5930c320541a52812906360e2acba.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e946b2aa06e1fe29dcd54f01ca9e83176651809a5208f552cfa02b12a94d9120.jpeg",
  location: "TEANECK, NJ, USA",
  minimumOrderDollars: 150,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "Hi! I'm Mia, the creator behind For the Love of Dough. I live in Teaneck, NJ with my husband and two children. For the Love of Dough was quite literally created from my love of dough and creating fun and engaging play time.\n\nI have spent hours playing with play dough with my toddler when I started to dream up combinations of dough and toys that I thought would make the best creative experience.\n\nFor the Love of Dough means so much to me and my family. I am so happy you are here. I hope you love it as much as we do.\n\nxo,\n\nMia",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:34.660Z",
    importedBy: "entity-db-cli",
  },
};
